<template>
  <div>
    <div class="head-container"  v-if="'edit' === Mode">
    
    <!-- リスト数 -->
    <div class="list-title-container">
      <h3 class="list-title">きみのテーマ</h3>
      <h3 class="list-title mini-display">テーマ</h3>
      <div class="list-title-count">
        {{items.length}}
        <span>こ</span>
      </div>
    </div>



     <!-- ==============================
    C: 今日の日付
    ==============================-->
     <div class="today-container">
      <h3 class="today-title"><span>きょうは</span></h3>
      <div class="today-body">
        {{FormatMomentObj(today,"M月D日")}}
        <span>{{FormatMomentObj(today,"(ddd)")}}</span>
      </div>
    </div>



    </div>

    <div class="container">
      <!-- 全体ローディング -->
      <t-loading class="loading-items" :isLoading="isLoadingItems"></t-loading>

        <!-- ==============================
        C: リスト一覧
        ==============================-->
       <draggable
      handle=".drag-handle"
        :list="items"
        @start="drag=true"
        @end="onMoveEndCallback"
      >
        <transition-group name="demo">


          <div
            class="item"
            ontouchstart=""
            v-for="(item,index) in items"
            :key="item.id"
            @mouseenter="OnHover(index)"
            @mouseleave="OnHover(null)"
            v-bind:class="{selected: item.id === selectedThink.id,disable:item.isLoading}"
          >
            <!-- 表示用 -->
            <!-- <div class="c-item-title" @click="StartEdit(item)"> -->
            <div class="c-item-title" >
              <!-- <i v-show="item.id === selectedThink.id" class="fas fa-angle-right"></i> -->
              <!-- <i v-show="item.id === selectedThink.id" class="fas fa-arrow-right"></i> -->
               <div class="drag-handle">
                <i class="fas fa-ellipsis-v"></i>
                <i class="fas fa-ellipsis-v"></i>
                <i class="fas fa-ellipsis-v"></i>
              </div>
              <div class="split-border">&nbsp;</div>
              <div class="no">{{index+1}}</div>
              <!-- <div class="split-border">&nbsp;</div> -->



              <span style="min-width:50px;" v-show="!item.isEdit" @click="StartEdit(item)" class="word-title">{{item.title}}</span>
              <div　class="mini-created handle"><span>つくったのは:</span> {{FormatTimestamp(item,"YYYY年M月D日(ddd)")}}</div>
              <!-- 入力用 -->
              <input
                v-show="item.isEdit"
                type="text"
                maxlength=50
                style="min-width:50px;"
                v-model="item.titleEditing"
                v-todo-focus="item.isEdit === true"
                @keydown.enter="Edited(item,index,$event)"
                @keyup.esc="Edited(item,index,$event)"
                class="c-input-area"
                @blur="Blur(item,index)"
              > 

              

              

              <!-- <div  v-if="'side-menu'!==Mode" class="split-border" style="margin-left:auto;">&nbsp;</div> -->

              <div class="column-context" style="margin-left:auto;">

                <!-- |||||||コンテキストメニュー -->
                <div class="button-container" >
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link c-btn-context-menu">
                      <i class="fas fa-ellipsis-h"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="DeleteItem(item)" ><i class="fa fa-trash-alt" style="margin-right:8px;"></i>削除する</el-dropdown-item>
                      <!-- <el-dropdown-item icon="el-icon-circle-plus">シェア</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>

              <div id="column-created-split-border" v-if="'side-menu'!==Mode" class=" split-border">&nbsp;</div>
              

              <!-- |||||||作成日時 -->
              <div class="column-created" v-if="'side-menu'!==Mode">
                <span class="created">
                  <span class="tag">つくったのは</span>
                  <span class="year">{{FormatTimestamp(item,"YYYY年")}}</span>
                   <span class="month-day">{{FormatTimestamp(item,"M月D日")}}</span>
                    <span class="week">{{FormatTimestamp(item,"(ddd)")}}</span>
                    <!-- <span class="day">{{FormatTimestamp(item,"DD日")}}</span> -->
                     <!-- <span class="time">{{FormatTimestamp(item,"HH:mm")}}</span> -->
                </span>
              </div>
               <div id="column-created-split-border" v-if="'side-menu'!==Mode" class=" split-border">&nbsp;</div>

          
            </div>

            

            
            

              <!-- |||||||言葉の数 -->
              <span　 v-if="'side-menu'!==Mode" v-bind:class="{zero: item.wordsCount == 0}"  @click.prevent="Selected(item)" class="words-count">
                  <!-- <span class="sub">ことば</span>  -->
                  {{item.wordsCount}}
                  <i class="fas fa-chevron-right"></i>
              </span>



            

            <!-- ローディング -->
            <t-loading class="loading-item" :isLoading="item.isLoading"></t-loading>
          </div>
        </transition-group>
      </draggable>
      <!-- 新規追加:ローディング -->
      <div class="item-for-loading" v-if="isAddingLoading">
        <t-loading class="loading-item" :isLoading="true"></t-loading>
      </div>

      <!-- 入力欄 -->
      <div class="input-content" v-show="false === isLoadingItems" style="margin-top:10px">
        <t-input
          v-model="newThink"
          ref="inputTheme"
          :maxlength=50
          placeholder="あたらしいテーマをとうろく"
          :enterToEditEnd="true"
          v-on:edited="AddThink"
          radius="26px"
        ></t-input>
      </div>

      <div class="otamesi-text" v-if="IsAnonymous===true">※おためしモードはテーマを「2つ」までつくれるよ！</div>
    </div>
  </div>
</template>

<script>
import Tloading from "./TLoading";
import draggable from "vuedraggable";
import TInput from "./TInput";
import Editable from "./Editable";
import moment from 'moment';

 moment.locale("ja");

export default {
  name: "think-list-component",
  components: {
    draggable,
    TInput,
    "t-loading": Tloading,
    "editable": Editable
  },
  data() {
    return {
      newThink: "",
      // OnEditMode: false, //編集モードフラグ　fix: 編集モード廃止
      hoverIndex: null,
      isAddingLoading: false,
      today:null
    };
  },
  props: {
    Mode: { type: String, default: "edit" }
  },
   mounted() {
    this.today = moment();

    if(this.isAnonymous)
    {
       this.$notify({
          title: 'おためしモードへようこそ',
          onClick:()=>{this.$notify.close();this.$router.push({ name: "ProfilePage" });},
          message: 'アカウントの登録はこちらをクリック',
          duration: 0,
          type: 'success'
        });
    }
  },
  directives: {
    "todo-focus": function(el, binding) {
      if (binding.value) {
        el.focus();
      }
    }
  },
  computed: {
    items: {
      get() {
        return this.$store.getters.thinkItems;
      },
      set(value) {
        this.$store.commit("SetThinks", value);
      }
    },
     IsAnonymous(){
      return this.$store.getters.loginUser.isAnonymous
    },
    selectedThink: {
      get() {
        return this.$store.getters.thinkData;
      }
    },
    isLoadingItems: {
      get() {
                
                if(this.$store.getters.Loading.Thinks==false)
                {
                  //入力欄にフォーカス
                  //this.$refs.inputTheme.ToFocus();
                  this.$nextTick(() => {
                      this.$refs.inputTheme.ToFocus();
                  })

                }

        return this.$store.getters.Loading.Thinks;
      }
    },
    limitForAdd:{
      get(){
        return this.$store.getters.LimitForSave.thinks;
      }
    }
  },
  methods: {
    ScrollBottom() {
      var container = document.querySelector("body");
      container.scrollTop = container.scrollHeight;
    },
    FormatTimestamp(item,format)
    {
      return moment.unix(item.created).format(format)

    },
    FormatMomentObj(momentObj,format)
    {
      if(momentObj === null)
      {
        return "";
      }
      return momentObj.format(format)

    },

    //==========================
    //ドラッグ後の処理
    //==========================
    onMoveEndCallback(evt) {
      if (evt.newIndex == evt.oldIndex) {
        return;
      }
      this.$store.dispatch("UpdateThinksOrder");
    },
    CheckZero(item) {
      return true;
    },
    OnHover(index) {
      if ("edit" !== this.Mode) {
        return;
      }
      this.hoverIndex = index;
    },
    //==========================
    //処理：削除
    //==========================
    DeleteItem(item) {
      this.$set(item, "isLoading", true); //Notice:リアクティブにするためのプロパティを追加して、有効にしている
      var containWordsCount = item.wordsCount;
      if (containWordsCount > 0) {
        if (
          false ==
          window.confirm(
            "ことばが「" +
              containWordsCount +
              "こ」ふくまれてるよ。削除（さくじょ）する？"
          )
        ) {
          item.isLoading = false;
          return;
        }
      }
      this.$store.dispatch("RemoveThink", item);
    },
    Blur(editedItem, index) {

      if(editedItem.isEdit)
      {
        this.Edited(editedItem, index);
        return;
      }
    },
    //==========================
    //編集:完了処理
    //==========================
    Edited(editedItem, index,e) {

      if(editedItem.titleEditing === editedItem.title)
      {
        editedItem.isEdit = false;
        return;
      }

      // 日本語入力中のEnterキー操作は無効にする
      if(e.keyCode!==13) {
        return;
      }


      this.$set(editedItem, "isLoading", true);

       var callback = function(result,msg) {
        if(result === false)
        {
          editedItem.titleEditing = editedItem.title
          alert(msg);
        }

        editedItem.title = editedItem.titleEditing
        editedItem.isEdit = false;
        editedItem.isLoading = false;
      }.bind(this);


      this.$store.dispatch("UpdateThink", {id:editedItem.id,title:editedItem.titleEditing,callback:callback});
      
    },
    //==========================
    //アイテム選択
    //==========================
    Selected(item) {
      //Notice: 編集中ならセレクトしない
      //編集中は選択させない
      // if (true === this.OnEditMode) {
      //   return;
      // }
      if (item.isEdit) {
        return;
      }
      
      this.$emit("selectThink", item);
    },
    //==========================
    //編集:開始処理
    //==========================
    StartEdit: function(item) {

      //Notice: 編集モードがONでないなら開始させない
      // fix 編集モード廃止にむけ、コメントアウト2020.01.08
      // if (false === this.OnEditMode) {
      //   return;
      // }

      item.isEdit = true;
      item.titleEditing = item.title
    },
    //==========================
    //編集:新規追加
    //==========================
    AddThink: function() {
      if (this.newThink === "") {
        return;
      }

      //データ入力制限
      if(this.items.length >= this.limitForAdd)
      {
        alert("つくれるテーマは"+this.limitForAdd + "こまでだよ。たくさんかんがえたね！えらい！")
        return;
      }

       if(this.IsAnonymous===true &&  this.items.length >= 2)
      {
   
        this.$message({
          dangerouslyUseHTMLString: true,
          message: '<strong>アカウント登録すれば３つ以上つくれるよ！</strong><p style="margin-top:10px;margin-left:10px;">☆※右上のなまえをクリック＞プロフィールからアカウント登録できます☆</p>',
          showClose: true,
          duration:25000,
        });
        return;
      }



      this.isAddingLoading = true;

      var itemIndex = this.items.length + 1; // 並び順を指定:一番最後

      var callback = function(newItem) {
        this.isAddingLoading = false;

        //作成後：次のページへ遷移する
        //＊作成後先にすすんでいないユーザーが３人いたのでその対策
        this.Selected(newItem)


      }.bind(this);

      this.$store.dispatch("AddThink", {
        newTitle: this.newThink,
        index: itemIndex,
        callback: callback
      });
      this.newThink = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
@import "./../assets/style/common.scss";
.demo-enter-active,
.demo-leave-active {
  transition: transform 0.8s, opacity 0.5s;
}
.demo-move:not(.demo-leave-active) {
  transition: transform 0.5s;
}
.demo-move {
  transition: none !important;
}
/* 表示される時は上からスライド */
.demo-enter {
  opacity: 0;
  transform: translateX(-10px);
  //transform: scaleY(0);
}
/* 消える時は縮小される */
.demo-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.demo-leave-active {
  position: absolute;
}

//選択されて、ドラッグされているもの（画像のコピー？）
.sortable-chosen {
  opacity: 1 !important;
  //background-color: #d4eee2; //薄いみどり

  //transform: translate(0, 0);
    box-shadow: 0px 4px #39af78!important;
    //transform: rotate(2deg);

}

//選択されて、もとの位置にあるもの
.sortable-ghost {
  opacity: 0 !important;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}


.mini-created{
  position:absolute;
  font-size:12px;
  font-weight: normal;
  bottom:6px;
  left:60px;
  font-size:10px;
  & > span{
    font-size:10px;
  }
  display: none;
  @include mq-down(md) { 
    display: block;
  }

}
//---------------
// 入力欄コンテンツ
//---------------
// .input-content{
//   position: absolute;/*←絶対位置*/
//     bottom: 0; /*下に固定*/
//     width:100%;

// }

//---------------
// 列：作成日時
//---------------
.column-created{
  position: relative;
  flex:0 0 130px;
  height:100%;
  padding-top:5px;

   @include mq-down(md) { 
    display: none;
  }
}
#column-created-split-border{


   @include mq-down(md) { 
    display: none;
  }

}
//---------------
// 作成日時
//---------------
.created{
  color:#666;
  top:0;
  display: block;
  

  margin-top:2px;
  margin-left:8px;
  

  & > .tag{
    display: block;
    transform-origin: left center; 
    transform: scale(0.6);
    color:#888;
    font-weight: normal;
    margin:0;
  }

  & > .year{
    
    font-weight: normal;
    //margin:-4px;

    padding-left:15px;
    font-size:10px;
    display: block;
  }
   & > .month-day{
     //margin-top:-5px;
    
     padding-left:15px;
    font-size:14px;
    
  }

  & > .week{
    font-size:12px;
  }
  & > .time{
    margin:0;
    padding:0;
    font-size:8px;
    display: block;
  }

}

//---------------
// コンテナ: ヘッド部分
//---------------
.head-container{
  display:flex;
}

//---------------
// コンテナ: テーマ数
//---------------
.list-title-container {
  margin-right: auto;
  // width: 280px;
  border: 2px solid #333;
  margin-bottom: 10px;
  display: flex;
  background:#fff;

  //---------------
  //  タイトル文字
  & > h3.list-title {

    letter-spacing: 0.1em;
    font-size: 16px;
    margin-left: 15px;
    margin-right: 15px;
    color: #666;

     @include mq-down(md) { 
      display:none;
    }

    &.mini-display{
      display:none;
      width:50px;
      font-size:12px;
       margin-left: 5px;
       margin-right: 5px;
      @include mq-down(md) { 
        display:block;
      }

    }
  }
  //---------------
  //カウント文字
  .list-title-count {
    
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #333;
    font-size: 18px;
    font-weight: 900;
    color:rgb(241, 241, 146);
    flex: 1 1 auto;
    padding-left: 2px;
    min-width:40px;

    //縁取り文字
    //color:#fff;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #666;
    text-shadow: 1px 2px 0px #666; 

    //---------------
    //カウント単位
    & > span {
      font-size: 10px;
      color: #666;
      margin-left: 3px;
      margin-top: 5px;

      //打ち消し: 親の縁取り文字スタイル
      -webkit-text-stroke-width: 0px;
      text-shadow: none; 
    }
  }
}

//---------------
// コンテナ:アイテム
//---------------
.item {

  &:active{
    //fix: クリックで背景に色がつくので、いったんストップ
    //background:rgb(255, 255, 151);
  }
  //---------------
  // :選択時のスタイル
  //---------------
  &.selected {
    //background: #f2faf6;
    background:rgb(255, 255, 151);
    //color:white;
    .c-item-title {
      & > .word-title {
        //background: linear-gradient(transparent 60%, yellow 60%);//マーカ
      }
    }
  }


  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;


  // OSブラウザでタップした要素が自動的に暗くなるのを防止する
  -webkit-tap-highlight-color:transparent; 

  //---------------
  // :無効時の処理
  //---------------
  &.disable {
    opacity: 0.3;
    cursor: default;
    pointer-events: none; // クリック、タッチを無効化
    // -文字を選択させない
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  &:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  &:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  position: relative;
  text-align: left;
  height: 60px;
  border: 1px solid #666;
  margin-bottom: -1px; //Notice:アイテム間のborderが太くなるのを防ぐ。
  padding-left: 0px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  
  background: #fff;
  //cursor: pointer;
  //transition: 0.15s;

  &:hover {
    //background-color: #d4eee2;
  }

  //---------------
  // :入力欄
  //---------------
  .c-input-area {
    width: 100%;
    background:transparent;
    font-weight: 600;
    font-size: 14px;
    border: none;
    padding: 0;
    outline: none;
    color:coral;
    @include mq-down(md) { 
         margin-bottom:7px;//表示用タイトルの位置にあわせる
    }
  }

  //---------------
  // :ドラッグハンドル
  //---------------
  .drag-handle
  {
    cursor: grab;
    align-items: center;
    display: flex;
    justify-content: center;
    flex:0 0 40px;
    font-weight: 900;
    text-align: center;
    color:#aaa;
    text-shadow: 1px 2px 0px #ccc;
  }

  .column-detail{
    cursor: grab;
    align-items: center;
    display: flex;
    justify-content: center;
    //flex: 1;
    align-items: stretch;
    color: #666;
    height: 100%;

    flex:0 0 100px;
    // background:yellow;
    // font-weight: 900;
    // text-align: center;
    // color:#aaa;
    // text-shadow: 1px 2px 0px #ccc;
  }

   //詳細表示
    .c-btn-detail{
      align-items: center;
      display: flex;
      justify-content: center;
      flex:0 0 40px;
      font-size:14px;
      color:gray;
      margin-right:10px;
      cursor: pointer;

    }



  //---------------
  // :表示欄
  //---------------
  .c-item-title {
    display: flex;
    flex: 1;
    align-items: stretch;
    color: #666;
    //background:yellow;
    height: 100%;
    //margin-right: 60px; //言葉数タグと重ならないよう、左にずらす



    //SEQ
    & > .no {
      align-items: center;
      display: flex;
      justify-content: center;
      flex:0 0 20px;
      font-weight: 900;
      //min-width:46px;
      text-align: center;
      // color:#42b983;
      color:#fff;

       -webkit-text-stroke-width: 1px;
       -webkit-text-stroke-color: #666;
       text-shadow: 1px 2px 0px #666; 

    }

    //タイトル
    .word-title {
      font-size:14px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      font-weight: 600;
      text-overflow: ellipsis;

      @include mq-down(md) { 
         margin-bottom:6px;
      }


    }

    // 区切り線
    & > div.split-border {
      flex: 0;
      margin-left: 0px;
      margin-right: 10px;
      width: 1px;
      background: #888;
      display: inline-block;
      //height: 100%;
      //border-left:solid 1px #42b983;
    }
  }

  .column-context{
   display: flex;
    flex:0 0 50px;
    height:100%;
    justify-content: center; /* 子要素をflexboxにより中央に配置する */
   // align-items: center;
    //background:yellow;
  }

  //---------------
  // :ボタン類
  //---------------
  .button-container {

    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: 900;
    text-align: center;
    color:#aaa;
    text-shadow: 1px 2px 0px #ccc;

  }

 
    //コンテキストメニューボタン
    .c-btn-context-menu{
      cursor: pointer;
    }

  //---------------
  // :ことば数
  //---------------
  .words-count {
    flex:0 0 45px;
    right: 16px;
    margin-right:10px;
    //margin-left:10px;
    //position: absolute;
    background: #42b983;
    border: 3px solid #a5eccc;
    color: white;
    padding-top: 8px;
    padding-bottom: 8px;
    display: inline-block;
    text-align: center;
    padding-left: 5px;
    padding-right: 1px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    text-shadow: 1px 2px 0px #666; 
    cursor: pointer;
    &:hover{
      background: coral!important;
      border: 3px solid rgb(250, 174, 147);
    }
    &.zero {
      background: silver !important;
      border: 3px solid rgb(221, 220, 220);
      //opacity: 0;
      text-shadow: none; 
    }

    & > .sub {
      font-size: 8px;
      font-weight: normal;
      margin-right: 3px;
    }

    & > i{
      margin-left:12px;
      text-shadow:none;
    }
  }
}
.theme {
  border-right: 1px solid #666;
  width: 120px;
  display: flex;
  justify-content: center; /* 子要素をflexboxにより中央に配置する */
  align-items: center; /* 子要素をflexboxにより中央に配置する */
  & > span {
    display: table-cell;
    font-weight: 600;
  }
}
.title {
  padding: 20px;
  font-size: 1.5em;
  font-weight: 600;
}

.loading-item {
  position: absolute;
  top: 19px;
  left: 20px;
  margin: auto;
  z-index: 999;
  transform: scale(1);
}
.item-for-loading {
  position: relative;
  text-align: left;
  height: 60px;
  border: 0px;
  margin-bottom: -1px; //Notice:アイテム間のborderが太くなるのを防ぐ。
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 20px;
  color: #42b983;
  transition: 0.4s;
}

//=======================
//今日の日付コンテナ
//=======================
.today-container {
  margin-left: 10px;
  width: 130px;
  height:30px;
  border: 2px solid #333;
  display: flex;
  align-items: stretch;
  position: relative;
  background:white;
  //---------------
  //  タイトル文字
  & > h3.today-title {
    position:absolute;
    letter-spacing: 0.1em;
    font-weight: normal;
    font-size: 12px;
    top:-33px;
  }
  //---------------
  //日付
  .today-body{
    display: flex;
    letter-spacing: 0.02em;
    justify-content: center;
    align-items: center;
    width:100%;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    //---------------
    //曜日部分
    & > span {
      font-size: 12px;
      color: #666;
      margin-left: 3px;
    }
  }
}
//=======================
//編集中スイッチのコンテナ
//=======================
.edit-mode-switch-container {
  margin-left: auto;
  
  cursor: pointer;
  // padding-bottom:10px;


  display: inline-block;
  padding-right: 6px;
  &:hover {
    & > span.label {
      opacity: 0.6;
    }
  }
  //ラベル
  & > span.label {
    margin-left: 1px;
    display: inline-block;
    margin-top: 6px;
    color: #666;

    @include mq-down(sm)
    {
      display: none;
    }


     @include mq-down(md) { 
      //display:none;
      
       margin-top: 0px;

     
    }

    // ラベル:編集時
    &.edit {
      color: coral;
      font-weight: 600;
    }
  }
}



.otamesi-text{
  margin-left:20px;
  font-weight: 600;
  color:#573F23;
}


[contenteditable="true"].title-item {
        white-space: nowrap;
        overflow: hidden;
} 
[contenteditable="true"].title-item br {
    display:none;
    
}
[contenteditable="true"].title-item * {
    display:inline;
    white-space:nowrap;
}

.title-item{
   font-size:14px;
      
      background:yellow;
      
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
    overflow: hidden;

      @include mq-down(md) { 
         margin-bottom:6px;
      }
  // OSブラウザでタップした要素が自動的に暗くなるのを防止する
    //-webkit-tap-highlight-color:transparent; 
     &:focus{
      outline:none;
    }

    
}
//=======================
//word-item:編集中
//=======================
  .title-item-edit-mode{
    //what: contenteditable設定で発生する枠線を消している
    border: none;
    outline-width: 0;
    //display: inline-block; // 編集文字が空白時にふきだしの左はしに移動してしまうのをふせぐ
    min-width: 5px;
  
    &:focus{
      color:coral;
    }

    // iOSでタップしても編集できないのを防ぐ。
    -webkit-user-select: text;
    user-select: text;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThinkList.vue